import React, { memo } from "react";
import SectionContainer from "./../../../../../common/SectionContainer";
import Surcharge from "./../../../../../common/SurchargeV2";

interface Props {
  isUpdateAllowed: boolean;
  bulk: boolean;
  shouldHideField: (fieldName: string) => boolean;
}

const EditSurchargeTippingComponent = ({ isUpdateAllowed, bulk, shouldHideField }: Props) => {
  return (
    <SectionContainer
      name="sections.Surcharge"
      heading="Surcharge & Tips"
      // level={1}
    >
      <Surcharge isUpdateAllowed={isUpdateAllowed} />
    </SectionContainer>
  );
};

export default memo(EditSurchargeTippingComponent);
